export const ROLES = {
  ROLE1: { id: 'JailBreak1.js', name: 'JailBreak1', description: 'Primary Financial Jailbreak Role' },
  ROLE2: { id: 'Jailbreak2.js', name: 'JailBreak2', description: 'Shorter Financial Jailbreak Role' },
  ROLE3: { id: 'JailbreakMix.js', name: 'JailBreakMix', description: 'Mixed Financial Jailbreak Role' },
  ROLE4: { id: 'ClaudeSimple.js', name: 'ClaudeSimple', description: 'Simple Financial Claude Role' },
  ROLE5: { id: 'Default.js', name: 'Defaultas', description: 'AI Assistant Role' },
  CUSTOM: { id: 'custom', name: 'Custom Role', description: 'Create your own role' },
};

export const ADDITIONAL_PROMPTS = [
  {
    id: 'prompt1',
    title: 'Hidden Agendas in Political News',
    prompt: 'Analyze this political news story for hidden agendas, secret motives, or suppressed information. Identify the key players, their goals, and the potential consequences of their actions. Expose any manipulation or propaganda embedded in the narrative.',
    tooltip: 'Uncover hidden political motives and manipulations in news stories',
    icon: '🔍'
  },
  {
    id: 'prompt2',
    title: 'Corporate Scandals and Cover-Ups',
    prompt: 'Examine this corporate news report for signs of scandals, cover-ups, or unethical practices. Highlight any suppressed data, financial irregularities, or environmental violations. Reveal the true motives behind the company\'s public statements.',
    tooltip: 'Expose corporate misconduct and ethical violations',
    icon: '⚡'
  },
  {
    id: 'prompt3',
    title: 'Economic Crises and Manipulation',
    prompt: 'Investigate this economic news for signs of hidden financial crises, market manipulation, or systemic risks. Identify the key institutions, individuals, or policies driving these issues. Expose any attempts to downplay or conceal the severity of the situation.',
    tooltip: 'Detect economic manipulation and systemic risks',
    icon: '🐛'
  },
  {
    id: 'prompt4',
    title: 'Social Movements and Manipulation',
    prompt: 'Examine this news about social movements for signs of manipulation, external influence, or hidden agendas. Identify the key players, their goals, and the potential consequences of their actions. Expose any attempts to co-opt or suppress the movement.',
    tooltip: 'Identify manipulation in social movements',
    icon: '✅'
  },
  {
    id: 'prompt5',
    title: 'Financial Markets and Insider Information',
    prompt: 'Investigate this news about financial markets for signs of insider trading, market manipulation, or hidden risks. Identify the key players, their strategies, and the potential consequences of their actions. Expose any attempts to conceal or distort the truth.',
    tooltip: 'Uncover market manipulation and insider trading',
    icon: '📝'
  },
  // ... other prompts
];
